/**
 * @generated SignedSource<<71b41268b21dc5938ac0d82d5f86310b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageEditTransportFlightsRowActions_packageDate$data = {
  readonly flight: {
    readonly id: string;
  } | null;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"CopyFlightButton_packageDate" | "PackageDateAddFlightDialog_packageDate">;
  readonly " $fragmentType": "PackageEditTransportFlightsRowActions_packageDate";
};
export type PackageEditTransportFlightsRowActions_packageDate$key = {
  readonly " $data"?: PackageEditTransportFlightsRowActions_packageDate$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditTransportFlightsRowActions_packageDate">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageEditTransportFlightsRowActions_packageDate",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Flight",
      "kind": "LinkedField",
      "name": "flight",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageDateAddFlightDialog_packageDate"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CopyFlightButton_packageDate"
    }
  ],
  "type": "PackageDate",
  "abstractKey": null
};
})();

(node as any).hash = "af41e0fe1add0ff80df91d23570a7ff8";

export default node;
